import { useState, useRef, useEffect } from 'react';
import { CaretDownIcon } from '@phosphor-icons/react';

function Accordion({ title, children, dynamicHeight = 20 }) {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight + dynamicHeight}px`;
    } else {
      contentRef.current.style.maxHeight = '0px';
    }
  }, [isOpen]);

  return (
    <div className="w-full border border-gray-120 rounded-lg px-4 py-3 mt-4">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-black text-sm font-['Inter'] font-normal">{title}</span>

        <CaretDownIcon className={`w-6 h-6 transform transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </div>
      <div
        ref={contentRef}
        className="overflow-hidden transition-max-height duration-500 ease-in-out"
        style={{ maxHeight: '0' }}
      >
        <div className="pt-4">
          {children}
        </div>
      </div>
    </div>
  );
}

export default Accordion;
